import { useEffect, useRef } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from 'sonner';

export function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(_r) {
      /* registered */
    },
    onRegisterError(err) {
      if (import.meta.env.DEV) console.warn('SW register error', err);
    },
  });

  const lastFiredRef = useRef(false);

  useEffect(() => {
    if (needRefresh && !lastFiredRef.current) {
      lastFiredRef.current = true;
      toast.message('Update available', {
        description: 'A newer version of Ember is ready.',
        duration: Infinity,
        action: {
          label: 'Refresh',
          onClick: () => void updateServiceWorker(true),
        },
      });
    }
    if (!needRefresh) lastFiredRef.current = false;
  }, [needRefresh, updateServiceWorker]);

  return null;
}
